/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiContainer, ApiCreateContainerRequest, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ContainersController.
 */
export class ContainersRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /containers:pool
     */
    public getPool(listRequest: ListRequest): Promise<Result<ListInfo<ApiContainer>>> {
        return this.http.post<Result<ListInfo<ApiContainer>>, ListRequest>('/containers:pool', listRequest);
    }

    /**
     * Calls POST /containers:prefill
     */
    public createPrefilledContainer(apiCreateContainerRequest: ApiCreateContainerRequest | undefined): Promise<Result<ApiContainer>> {
        return this.http.post<Result<ApiContainer>, ApiCreateContainerRequest | undefined>('/containers:prefill', apiCreateContainerRequest);
    }

    /**
     * Calls POST /containers/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiContainer>>> {
        return this.http.post<Result<LockedContextDto<ApiContainer>>, undefined>(`/containers/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /containers/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiContainer>> {
        return this.http.post<Result<ApiContainer>, undefined>(`/containers/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /containers/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiContainer[]>> {
        return this.http.post<Result<ApiContainer[]>, string[]>('/containers/locks', ids);
    }

    /**
     * Calls POST /containers/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/containers/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /containers/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/containers/${primaryId}/locks`);
    }

    /**
     * Calls GET /containers/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiContainer>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiContainer>>(`/containers/${primaryId}`, query);
    }

    /**
     * Calls POST /containers
     */
    public add(dto: ApiContainer): Promise<Result<ApiContainer>> {
        return this.http.post<Result<ApiContainer>, ApiContainer>('/containers', dto);
    }

    /**
     * Calls PUT /containers/{primaryId}
     */
    public update(dto: ApiContainer, primaryId: string): Promise<Result<ApiContainer>> {
        return this.http.put<Result<ApiContainer>, ApiContainer>(`/containers/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /containers
     */
    public putRange(dtos: ApiContainer[]): Promise<Result<ApiContainer[]>> {
        return this.http.patch<Result<ApiContainer[]>, ApiContainer[]>('/containers', dtos);
    }

    /**
     * Calls DELETE /containers/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/containers/${primaryId}`);
    }

    /**
     * Calls POST /containers:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiContainer>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiContainer>>, ListRequestWithIds>('/containers:batch', listRequest, query);
    }

    /**
     * Calls POST /containers:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiContainer>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiContainer>>, ListRequest>('/containers:query', listRequest, query);
    }

    /**
     * Calls GET /containers:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiContainer>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiContainer>>>('/containers:query', query);
    }
}
